<template>

	<div class="color-selection">
	    <p class="h3 mb-2 pt-2 pb-4">Quelle est la puissance souhaitée ?</p>

	    <div class="row two-parts">
	      <div class="col-lg-7">
	        <ul class="list-unstyled">
	          <li>
	            <img class="w-100" src="../assets/img/radiateurs/radiateur-test.png">
	          </li>
	        </ul>
	      </div>
	      <div class="col-lg-5 pl-4 pr-md-0 d-flex flex-column justify-content-center">

	      	<div class="d-flex justify-content-between align-items-center pb-3">
	          <button class="ml-3 more-btn" @click='value+=-50'><i class="fas fa-minus-circle"></i></button>
	          <p class="h1">{{value}} W</p>
	          <button class="mr-3 more-btn" @click='value+=50'><i class="fas fa-plus-circle"></i></button>
	        </div>
	        <div class="form-group mb-4">
	          <vue-range-slider :min="450" :step="50" :max="4000" ref="slider" v-model="value" tooltip="hover" tooltip-dir="bottom" formatter="{value} W"></vue-range-slider>
	          <div class="caption-range mt-2">
	            <span class="min">450 W</span>
	            <span class="max">4000 W</span>
	          </div>
	        </div>

	        <!-- Si un seul radiateur proposé -> vers color / Si plusieurs radiateurs -> Power show pour selectionner  -->
	        <router-link :to="{name:'PowerShow'}" class="btn btn-md btn-primary mt-3 rounded-pill">
	          Étape suivante
	        </router-link>
	      </div>
	    </div>
	</div>

</template>

<script>

	import 'vue-range-component/dist/vue-range-slider.css';
 	import VueRangeSlider from 'vue-range-component';

	export default {
	name: "PowerSelection",
	data() {
	  return {
	    value: 1000
	  }
	},
    created(){
      if (this.state.power_selected)this.value = this.state.power_selected;
    },
	components: {VueRangeSlider},
    watch:{
      value(){
        this.setData('power_selected',this.value)
      }
    },
	}

</script>
